module.exports = __webpack_public_path__ + "img/icon_overtime_1.6c2e729c.svg";